import matchSorter from 'match-sorter';

export function getItems(items, filter) {
  return (filter
    ? matchSorter(items, filter, {
        keys: ['n'],
      })
    : items).slice(0,100);
}
